import React, { useMemo } from "react";
import { Container, Row, Col, Card, Form, Button } from "reactstrap";
import { SwitchSelect, CustomButton, SelectDropdown, DatePicker, } from "./FormInputs";
import BreadCrumb from "./BreadCrumb";
import useMaster from "../../hooks/useMaster";
import { useLocation } from 'react-router-dom';
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
const PageLayout = ({
    values,
    handleToggleChange,
    loading,
    handleSubmit,
    status,
    children,
    btn_2,
    handleDuplicate,
    search,
    customerData = [],
    statusData = [],
    setValues,
    handleCustomerSearch,
    handleCancel,
}) => {
    const { slug } = useParams()

     const profile_Details = useSelector(state => state.globalslice.profile_Details);
      const isAppView = profile_Details?.source === "app";

    const { getMenuAccess } = useMaster()
    const { isLoadingMenu, data: menuData } = getMenuAccess()

    const location = useLocation();
    const pathname = location.pathname;
    const basePath = `/${pathname.split('/').filter(Boolean).slice(0, 2).join('/')}`;

    const { parentTitle, submenuTitle, opParentId, parentNameFromOpId, parentUrlPath } = useMemo(() => {
        let parent = null;
        let submenu = null;

        for (const menu of (menuData?.data || [])) {
            const found = menu.submenus?.find((sub) => sub.url_path === basePath);
            if (found) {
                parent = menu;
                submenu = found;
                break;
            }
        }

        let parentNameFromOpId = '';
        let parentUrlPath = '';
        if (submenu?.op_parentid) {
            for (const menu of menuData.data) {
                const match = menu.submenus?.find((sub) => sub.id === submenu.op_parentid);
                if (match) {
                    parentNameFromOpId = match.name;
                    parentUrlPath = match.url_path;
                    break;
                }
            }
        }


        return {
            parentTitle: parent?.page_title || parent?.name || '',
            submenuTitle: submenu?.page_title || submenu?.name || '',
            opParentId: submenu?.op_parentid,
            parentNameFromOpId,
            parentUrlPath
        };

    }, [menuData, location.pathname]);

    return (
        <div className={`page-content ${isAppView ? "remove_pagecontent" : ""}`}>
            <Container fluid>
                {
                      !isAppView && (
                <BreadCrumb parentTitle={parentTitle} pageTitle={submenuTitle} operationParent={parentNameFromOpId} parentUrlPath={parentUrlPath} />
                      )
                      }
                {search != undefined &&
                    <Form onSubmit={handleSubmit}>
                        <Row>
                            <Col lg={12}>
                                <Card className="w-100">
                                    <Row className="align-items-center">
                                        <Col lg={3}>
                                            <SelectDropdown
                                                label="Select Customer"
                                                options_data={customerData}
                                                name="customer"
                                                setValues={setValues}
                                                values={values}
                                                value={values.customer}
                                                isMultiple={false}
                                                onSearch={handleCustomerSearch}
                                            />
                                        </Col>
                                        <Col lg={3}>
                                            <SelectDropdown
                                                label="Select Status"
                                                options_data={statusData}
                                                name="status"
                                                setValues={setValues}
                                                values={values}
                                                value={values.status}
                                                isMultiple={false}
                                            />
                                        </Col>
                                        <Col lg={3}>
                                            <DatePicker
                                                label={'Start and End Date'}
                                                mode="range"
                                                enableTime={true}
                                                value={values.delivery_date}
                                                name={'delivery_date'}
                                                setValues={setValues} />
                                        </Col>
                                        <Col lg={3}>
                                            <div class="d-flex justify-content-end gap-2">
                                                <button type="button" class="btn btn-danger" onClick={handleCancel}> Cancel</button>
                                                <button type="submit" class="btn btn-primary add-btn" id="create-btn" handleSubmit={handleSubmit}> Search</button>
                                            </div>
                                        </Col>
                                    </Row>
                                </Card>
                            </Col>
                        </Row>
                    </Form>
                }
                {children}
                {(search == undefined &&
                    handleSubmit != undefined) &&
                    <Row>
                        <Col lg={12}>
                            <Card className="w-100">
                                <div className={`d-flex ${status === undefined ? "justify-content-between align-items-center" : "justify-content-end"} m-3`}>
                                    {status === undefined &&
                                        <SwitchSelect
                                            label="Status"
                                            name="rstatus"
                                            handleToggleChange={handleToggleChange}
                                            checked={values.rstatus}
                                        />}
                                    <div className="d-flex">
                                        {
                                            (slug && btn_2) &&
                                            <Button color="primary" outline className="btn-sm me-2" onClick={handleDuplicate}>
                                                Duplicate
                                            </Button>
                                        }
                                        <CustomButton handleSubmit={handleSubmit} label="Submit" loading={loading}/>
                                    </div>
                                </div>
                            </Card>
                        </Col>
                    </Row>
                }
            </Container>
        </div>
    )
}

export default PageLayout